export const options3 = [



    {
        "value": "浙江省",
        "label": "浙江省",
        "children": [{
                "value": "湖州市",
                "label": "湖州市",
                "children": [{
                        "value": "吴兴区",
                        "label": "吴兴区",
                        "children": [{
                                "value": "织里镇",
                                "label": "织里镇"
                            },
                            {
                                "value": "八里店镇",
                                "label": "八里店镇"
                            },
                            {
                                "value": "龙泉街道",
                                "label": "龙泉街道"
                            },
                            {
                                "value": "湖东街道",
                                "label": "湖东街道"
                            },
                            {
                                "value": "月河街道",
                                "label": "月河街道"
                            },
                            {
                                "value": "埭溪镇",
                                "label": "埭溪镇"
                            },
                            {
                                "value": "朝阳街道",
                                "label": "朝阳街道"
                            },
                            {
                                "value": "东林镇",
                                "label": "东林镇"
                            },
                            {
                                "value": "飞英街道",
                                "label": "飞英街道"
                            },
                            {
                                "value": "环渚街道",
                                "label": "环渚街道"
                            },
                            {
                                "value": "爱山街道",
                                "label": "爱山街道"
                            },
                            {
                                "value": "道场乡",
                                "label": "道场乡"
                            },
                            {
                                "value": "妙西镇",
                                "label": "妙西镇"
                            }
                        ],
                    }, 
                


                    {
                        "value": "南太湖新区",
                        "label": "南太湖新区",
                        "children": [{
                                "value": "杨家埠街道",
                                "label": "杨家埠街道"
                            },
                            {
                                "value": "仁皇山街道",
                                "label": "仁皇山街道"
                            },
                            {
                                "value": "康山街道",
                                "label": "康山街道"
                            },
                            {
                                "value": "凤凰街道",
                                "label": "凤凰街道"
                            },
                            {
                                "value": "滨湖街道",
                                "label": "滨湖街道"
                            },
                            {
                                "value": "龙溪街道",
                                "label": "龙溪街道"
                            }

                        ],
                    }, 
                    
            
                ]
            }


        ]
    }
]